import { apiRequest } from "./client";

export type CreateGrievanceResponse = {
  grievance_id: number;
  attachment_uploaded: boolean;
};

export function createGrievance(
  applicationId: string,
  grievanceText: string,
  attachment: File | null,
): Promise<CreateGrievanceResponse> {
  const fd = new FormData();
  fd.append("application_id", applicationId);
  fd.append("grievance_text", grievanceText);
  if (attachment) fd.append("attachment", attachment);
  return apiRequest<CreateGrievanceResponse>("/student/grievances", {
    method: "POST",
    formData: fd,
  });
}
